const GET_AZURE_CONSOLE_LOGS = "GET_AZURE_CONSOLE_LOGS";
const GET_AZURE_CONSOLE_LOGS_SUCCESS = "GET_AZURE_CONSOLE_LOGS_SUCCESS";
const GET_AZURE_CONSOLE_LOGS_ERROR = "GET_AZURE_CONSOLE_LOGS_ERROR";

export {
  GET_AZURE_CONSOLE_LOGS,
  GET_AZURE_CONSOLE_LOGS_SUCCESS,
  GET_AZURE_CONSOLE_LOGS_ERROR,
};
